import React, { useState, useEffect } from "react";

import styles from "./Countdown.module.css";

interface Props {
  // endTime: number;
  // handleUpdateGoods: Function
  remainTime: number
}

const Countdown: React.FC<Props> = props => {
  const { remainTime } = props;

  const [time, setTime] = useState(0);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [second, setSecond] = useState(0);

  useEffect(() => {
    const diff = (remainTime) / 1000;
    setTime(diff);
    setDay(Math.floor(diff / 60 / 60 / 24));
    setHour(Math.floor((diff / 60 / 60) % 24));
    setMinute(Math.floor((diff / 60) % 60));
    setSecond(Math.floor(diff % 60));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[remainTime])
  // useEffect(() => {
  //   const cd = setInterval(() => {
  //     const now = Date.now();
  //     const diff = (endTime - now) / 1000;
  //     setTime(diff);
  //     setHour(Math.floor((diff / 60 / 60) % 24));
  //     setMinute(Math.floor((diff / 60) % 60));
  //     setSecond(Math.floor(diff % 60));
  //   }, 1000);
  //   return () => clearInterval(cd);
  // }, [endTime]);

  return (
    <div className={styles.container}>
      {time < 0 ? (
        <em className={styles.end}>已结束</em>
      ) : (
        <>
          <span className={styles.label}>距离结束:</span>
          <em className={styles.time}>
          {day > 0 ? day + '天' : ''}{hour}小时{minute}分钟{second}秒
          </em>
        </>
      )}
    </div>
  );
}

export default Countdown;
